import Projects from 'containers/Mail/Projects';
import Categories from 'containers/Mail/Categories';
import EmailTemplates from 'containers/Mail/Templates';
import SendEmails from 'containers/Mail/SendEmails';
import TemplateABTest from 'containers/Mail/TemplateABTest';
import MailingHistory from 'containers/Mail/MailingHistory';
import { addComponentsToRoutes } from 'services/common';
import routes from './routesOnNav';
import AuthorizeGmailAccount from '../../containers/Mail/Gmail/AuthorizeGmailAccount';
import TemplateReport from '../../containers/Mail/TemplateReport';
import Utilities from '../../containers/Mail/Utilities';
import EmailTypes from '../../containers/Mail/EmailTypes';
import SpamWords from 'containers/Mail/SpamWords';
import EnochConfig from 'containers/Mail/EnochConfig';
import ThrottleExemption from 'containers/Mail/ThrottleExemption';

const components = {
  '/mail/projects': Projects,
  '/mail/categories': Categories,
  '/mail/types': EmailTypes,
  '/mail/email-templates': EmailTemplates,
  '/mail/template-report': TemplateReport,
  '/mail/send-emails': SendEmails,
  '/mail/template-ab-test': TemplateABTest,
  '/mail/history': MailingHistory,
  '/mail/gmail': AuthorizeGmailAccount,
  '/mail/throttle-exemptions': ThrottleExemption,
  '/mail/utilities': Utilities,
  '/mail/spam-words': SpamWords,
  '/mail/enoch-config': EnochConfig,
};

export default addComponentsToRoutes(routes, components);
